import './app.scss';
import './index.scss';
import PrivateRoute from './utils/PrivateRoute'
import { AuthProvider } from './context/AuthContext';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './pages/auth/login'
import Register from './pages/auth/register'
import PasswordReset from './pages/auth/password-reset'
import PasswordResetConfirm from './pages/auth/password-reset-confirm'
import Dashboard from './pages/Dashboard'
import ProfilePage from './pages/profiles/profileDetail'
import ClientProfile from './pages/clients/clientProfile'
import HeaderComp from './components/Header'
import Footer from "./components/Footer"
import NotFound from "./pages/error/NotFound"
import GeneralSettings from './pages/system/settings';
import ChangeLog from './pages/system/changeLog';
import EmailSettings from './pages/system/email';
import CurrenciesSettings from './pages/system/currencies';
import AddClients from './pages/clients/addClient';
import CountriesSettings from './pages/system/countries';
import ProjectList from './pages/projects/projectList';
import AddProjects from './pages/projects/addProject';
import ClientContacts from './pages/clients/clientContacts';
import ClientNotes from './pages/clients/clientNotes';
import ClientSettings from './pages/clients/clientSettings';
import ProjectProfile from './pages/projects/projectProfile';
import ClientShell from './pages/clients/clientShell';
import AgreementList from './pages/agreements/agreementList';
import AgreementShell from './pages/agreements/agreementShell';
import TaxRatesSettings from './pages/system/taxrates';
import AddAgreement from './pages/agreements/addAgreement';
import SignatureShell from './pages/agreements/publicSign';
import SubmissionList from './pages/agreements/submissionList';
import SubmissionShell from './pages/agreements/submissionShell';
import CountiesSettings from './pages/system/counties';
import ProvincesSettings from './pages/system/provinces';
import FLPTSEmailSettings from './pages/system/flptsemail';

function App() {
  return (
    <div className="App">
      <div className="page-wrapper">
        <Router>
          
          <AuthProvider>
            <HeaderComp />
            <Switch>
              <PrivateRoute exact path="/" component={Dashboard} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/password-reset" component={PasswordReset} />
              <Route exact path="/password-reset-confirm/:id/:token" component={PasswordResetConfirm} />
              <Route exact path="/sign-agreement/:id" component={SignatureShell} />
              <PrivateRoute exact path="/profile/:id" component={ProfilePage} />
              <PrivateRoute exact path="/agreements" component={AgreementList} />
              <PrivateRoute exact path="/agreements/add" component={AddAgreement} />
              <PrivateRoute exact path="/agreements/:id" component={AgreementShell} />
              <PrivateRoute exact path="/submissions" component={SubmissionList} />
              <PrivateRoute exact path="/submissions/:id" component={SubmissionShell} />
              <PrivateRoute exact path="/clients/add" component={AddClients} />
              <PrivateRoute exact path="/client/dashboard/:id" component={ClientShell} />
              <PrivateRoute exact path="/client/details/:id" component={ClientShell} />
              <PrivateRoute exact path="/client/contacts/:id" component={ClientShell} />
              <PrivateRoute exact path="/client/notes/:id" component={ClientShell} />
              <PrivateRoute exact path="/client/settings/:id" component={ClientShell} />
              <PrivateRoute exact path="/projects" component={ProjectList} />
              <PrivateRoute exact path="/projects/add" component={AddProjects} />
              <PrivateRoute exact path="/projects/details/:id" component={ProjectProfile} />
              <PrivateRoute exact path="/system/settings/general" component={GeneralSettings} />
              <PrivateRoute exact path="/system/settings/changelog" component={ChangeLog} />
              <PrivateRoute exact path="/system/settings/email" component={EmailSettings} />
              <PrivateRoute exact path="/system/settings/email/flpts" component={FLPTSEmailSettings} />
              <PrivateRoute exact path="/system/settings/financial/currencies" component={CurrenciesSettings} />
              <PrivateRoute exact path="/system/settings/financial/tax-rates" component={TaxRatesSettings} />
              <PrivateRoute exact path="/system/settings/reference-data/geographical/provinces" component={ProvincesSettings} />
              <PrivateRoute exact path="/system/settings/reference-data/geographical/countries" component={CountriesSettings} />
              <PrivateRoute exact path="/system/settings/reference-data/geographical/counties" component={CountiesSettings} />
              <Route component={NotFound} />
            </Switch>
            <Footer />
          </AuthProvider>
        </Router>
      </div>
    </div>
  );
}

export default App;
